/**
 * Sort Pills Component
 * 
 * Pill-style filter buttons: New, Top, Trending
 */
import { __ } from '@wordpress/i18n';

const SortPills = ({ activeSort, onSortChange }) => {
    const sortOptions = [
        { value: 'new', label: __( 'New', 'changeloger' ), icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="secondary-svg mr-1.5"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path></svg>' },
        { value: 'top', label: __( 'Top', 'changeloger' ), icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="secondary-svg mr-1.5"><path fill-rule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clip-rule="evenodd"></path></svg>' },
        { value: 'trending', label: __( 'Trending', 'changeloger' ), icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="secondary-svg mr-1.5"><path fill-rule="evenodd" d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z" clip-rule="evenodd"></path></svg>' }
    ];

    return (
        <div className="cha-sort-pills">
            {sortOptions.map(option => (
                <button
                    key={option.value}
                    className={`cha-sort-pill ${activeSort === option.value ? 'active' : ''}`}
                    onClick={() => onSortChange(option.value)}
                >
                    <span className="cha-pill-icon" dangerouslySetInnerHTML={{ __html: option.icon }} />
                    {option.label}
                </button>
            ))}
        </div>
    );
};

export default SortPills;
